import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.blue.light.compact.css';
import '@botto/core/theme';
import './styles/app.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import dxConfig from 'devextreme/core/config';

import App from './App.vue';
import { router } from './router';
import { env } from './config/env';

if (env.devextremeLicenseKey) {
  dxConfig({ licenseKey: env.devextremeLicenseKey });
} else if (env.isDev) {
  console.warn('[auth-ui] VITE_DEVEXTREME_LICENSE_KEY is empty — DevExtreme trial mode');
}

const app = createApp(App);
app.use(createPinia());
app.use(router);

// Не использовать top-level await: entry-чанк экспортирует api/utils для lazy-views,
 // и await isReady() + circular import блокирует mount (пустой #app в production).
router.isReady().then(() => {
  app.mount('#app');
});
